import { createContext, useState, useEffect, useContext, useCallback } from 'react';

export const SuperAuthContext = createContext(null);

export function SuperAuthProvider({ children }) {
  const [superAdmin, setSuperAdmin] = useState(null);
  const [saToken,    setSaToken]    = useState(null);
  const [loading,    setLoading]    = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('trainaxis_sa_token');
    const admin = localStorage.getItem('trainaxis_sa_user');
    if (token && admin) {
      try {
        setSaToken(token);
        setSuperAdmin(JSON.parse(admin));
      } catch {
        localStorage.removeItem('trainaxis_sa_token');
        localStorage.removeItem('trainaxis_sa_user');
      }
    }
    setLoading(false);
  }, []);

  const loginSA = useCallback((adminData, tokenData) => {
    setSuperAdmin(adminData);
    setSaToken(tokenData);
    localStorage.setItem('trainaxis_sa_token', tokenData);
    localStorage.setItem('trainaxis_sa_user', JSON.stringify(adminData));
  }, []);

  const logout = useCallback(() => {
    setSuperAdmin(null);
    setSaToken(null);
    localStorage.removeItem('trainaxis_sa_token');
    localStorage.removeItem('trainaxis_sa_user');
  }, []);

  return (
    <SuperAuthContext.Provider value={{ superAdmin, saToken, loading, loginSA, logout }}>
      {children}
    </SuperAuthContext.Provider>
  );
}

export const useSuperAuth = () => useContext(SuperAuthContext);
